import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { modules } from "@/data/modules";

// Bento grid - asymmetric layout (10 modules)
const layouts = [
  "col-span-6 md:col-span-4", "col-span-6 md:col-span-2",
  "col-span-6 md:col-span-2", "col-span-6 md:col-span-4",
  "col-span-6 md:col-span-3", "col-span-6 md:col-span-3",
  "col-span-6 md:col-span-2", "col-span-6 md:col-span-4",
  "col-span-6 md:col-span-3", "col-span-6 md:col-span-3",
];

export default function FeatureBento() {
  return (
    <section className="py-20 md:py-32">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-end justify-between mb-14 flex-wrap gap-4">
          <div className="max-w-2xl">
            <div className="text-xs font-bold tracking-[0.2em] uppercase text-[#00A651] mb-3">Modules</div>
            <h2 className="text-3xl md:text-5xl font-extrabold tracking-tighter text-[#1F1E4E]">
              A modern HR toolkit. Every module you need, none you don't.
            </h2>
          </div>
          <Link to="/features" className="text-sm font-bold text-[#00A651] hover:text-[#008A43] inline-flex items-center gap-1">
            Explore all features <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>

        <div className="grid grid-cols-6 gap-5">
          {modules.map((m, i) => {
            const I = m.icon;
            return (
              <Link
                key={m.slug}
                to={`/software/${m.slug}`}
                data-testid={`bento-${m.slug}`}
                className={`${layouts[i]} group bg-white rounded-2xl border border-slate-200 p-7 hover:-translate-y-1 hover:shadow-lg transition-all`}
              >
                <div className="flex items-start justify-between mb-6">
                  <div className="h-11 w-11 rounded-xl bg-[#E6F6EC] flex items-center justify-center">
                    <I className="h-5 w-5 text-[#00A651]" />
                  </div>
                  <ArrowUpRight className="h-4 w-4 text-slate-300 group-hover:text-[#00A651] transition-colors" />
                </div>
                <div className="text-lg font-extrabold text-[#1F1E4E] tracking-tight">{m.name}</div>
                <div className="text-sm text-slate-500 mt-2 leading-relaxed">{m.tagline}</div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
